import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c1c8a50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { queryDeviceInfoByGatewayDeviceId } from '@/api'
import { CODE_ENUM } from '@/common'
import i18n from '@/i18n'
import subDevicecommandRecordDrawer from './sub-device-command-record-drawer.vue'
import subDevicecommandDrawer from './sub-device-command-drawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'sub-device-table',
  setup(__props) {

const t = i18n.global.t

const tableData = ref([])
const tableLoading = ref(false)

const $route = useRoute()

const deviceId = $route.query.deviceId || ''

const fetchList = async () => {
  const res: any = await queryDeviceInfoByGatewayDeviceId({
    gatewayDeviceId: deviceId,
  })
  console.log(res.data, '')
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data || []
  }
}

onMounted(() => {
  fetchList()
})

const col: any = [
  {
    type: 'index',
    label: t('D_DATA.index'),
    width: 80,
  },
  {
    prop: 'deviceName',
    label: t('D_DATA.deviceName'),
  },
  {
    prop: 'producer',
    label: t('D_DATA.producer'),
  },
  {
    prop: 'brand',
    label: t('D_DATA.brand'),
    formatter: ({ brand, productModel }: any) => {
      return [brand, productModel].filter(Boolean).join('/') || '-'
    },
  },
  {
    prop: 'deviceSn',
    label: t('D_DATA.deviceSn'),
  },
  {
    prop: 'variable',
    label: t('D_DATA.variable'),
  },
]

const commandConf = ref({
  visible: false,
  data: {},
})

const handleCommand = ({ deviceId }: any) => {
  commandConf.value = {
    visible: true,
    data: {
      deviceId,
    },
  }
}

const commandRecordConf = ref({
  visible: false,
  data: {},
})

const handleCommandRecord = ({ deviceId }: any) => {
  commandRecordConf.value = {
    visible: true,
    data: {
      deviceId,
    },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table ws_mt24"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            description: _ctx.$t('D_DATA.noData')
          }, null, 8, ["description"])
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, { ...item }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64)),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('D_DATA.operation'),
            width: "180"
          }, {
            default: _withCtx((scoped) => [
              (scoped.row.instructFlag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (handleCommand(scoped.row)),
                      class: "command-span"
                    }, _toDisplayString(_ctx.$t('D_DATA.commandIssuance')), 9, _hoisted_3),
                    _createVNode(_component_el_divider, {
                      direction: "vertical",
                      class: "ws_ml15 ws_mr15"
                    }),
                    _createElementVNode("span", {
                      onClick: ($event: any) => (handleCommandRecord(scoped.row)),
                      class: "command-span"
                    }, _toDisplayString(_ctx.$t('D_DATA.commandRecord')), 9, _hoisted_4)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ])
    ]),
    _createVNode(subDevicecommandDrawer, {
      visible: commandConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((commandConf.value.visible) = $event)),
      data: commandConf.value.data
    }, null, 8, ["visible", "data"]),
    _createVNode(subDevicecommandRecordDrawer, {
      visible: commandRecordConf.value.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((commandRecordConf.value.visible) = $event)),
      data: commandRecordConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})